import { Card } from '@/components/Card/Card';
import { t } from '@/lib/i18n';
import styles from './HowItWorksStrip.module.css';

interface Step {
  number: '01' | '02' | '03';
  title: string;
  body: string;
  glyph: string;
}

export function HowItWorksStrip() {
  const steps: Step[] = [
    {
      number: '01',
      title: t('Pick a teammate.'),
      body: t(
        'By position. Brenda for the books. Marcus for analytics. The team grows with what you need.',
      ),
      glyph: '+',
    },
    {
      number: '02',
      title: t('Tell them what you need.'),
      body: t(
        'Plain English. Like talking to anyone on staff. They ask questions if they need to.',
      ),
      glyph: '▤',
    },
    {
      number: '03',
      title: t('Get the work back.'),
      body: t('Finished. You approve, or ask for changes.'),
      glyph: '▶',
    },
  ];

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>{t('Three moves.')}</h2>
      <div className={styles.grid}>
        {steps.map((step) => (
          <Card key={step.number} padding="lg" className={styles.step}>
            <span
              className={styles.stepNumber}
              data-testid="how-it-works-number"
              aria-hidden="true"
            >
              {step.number}
            </span>
            <span className={styles.stepIcon} aria-hidden="true">
              {step.glyph}
            </span>
            <h3 className={styles.stepTitle}>{step.title}</h3>
            <p className={styles.stepBody}>{step.body}</p>
          </Card>
        ))}
      </div>
    </section>
  );
}
